import '../styles/Overlay.css';

import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import React from 'react';
import Typography from '@mui/material/Typography';

interface OverlayProps {
  spinner: boolean;
  spinnerSize?: number; // in pixels
  message?: string;
  component?: JSX.Element;
  top?: number; // * defaults to 50px
  bottom?: number; // * defaults to 30px
}

const Overlay = (props: OverlayProps) => {
  const overrideStyle = {
    top: `${props.top}px` || '50px',
    bottom: `${props.bottom}px` || '30px'
  };

  return (
    <div className="overlay" style={overrideStyle}>
      {props.spinner && <CustomLoadingProgress size={props.spinnerSize} />}
      {props.message && (
        <Typography className="message" component="h4">
          {props.message}
        </Typography>
      )}
      {props.component && <div className="component">{props.component}</div>}
    </div>
  );
};

export default Overlay;
